import { type ComponentProps } from 'react';
import { Colors, Flex, IconChevronRight, Typography } from '@banhala/ui-kit';

type FlexPadding = ComponentProps<typeof Flex.Row>['padding'];

interface ViewAllButtonProps {
  onPress: () => void;
  /**
   * 버튼 내부 패딩을 오버라이드할 때 사용.
   *
   * 기본값: { horizontal: 12 } (네이티브 ViewAllButton.kt 기준)
   *
   * HeadlineRightPanel(type='textButton') 안에서는 left:12가 이미
   * 적용되므로, 중복 방지를 위해 { right: 4 } 등으로 조정한다.
   */
  padding?: FlexPadding;
}

/**
 * 네이티브 ViewAllButton.kt와 동일한 "전체보기 >" 버튼.
 *
 * - 텍스트: body3, content_positive (#6093FC)
 * - 아이콘: 16px, content_blue_primary (#2572F7)
 * - 기본 내부 패딩: horizontal 12 (네이티브 padding(horizontal = 12.dp))
 */
export const ViewAllButton = ({
  onPress,
  padding = { horizontal: 12 },
}: ViewAllButtonProps) => (
  <Flex.Row
    height={40}
    padding={padding}
    alignItems="center"
    gap={4}
    onPress={onPress}
  >
    <Typography type="body3" color="content_positive">
      전체보기
    </Typography>
    <IconChevronRight
      width={16}
      height={16}
      fill={Colors.content_blue_primary}
    />
  </Flex.Row>
);
